module.exports = __webpack_public_path__ + "b9c0bddf4214aaf14b1aca70c5cc94d3.svg";